import { useQuery } from '@tanstack/react-query';
import type { CustomerGroupApiResponse } from '../types/customer-group-response';
import { useCustomerGroupsApi } from './use-customer-groups-api';

export const QK_GET_CUSTOMER_GROUPS = () => ['customer_groups'] as const;

export function useCustomerGroups() {
  const { customerGroupsApi } = useCustomerGroupsApi();

  const query = useQuery<CustomerGroupApiResponse[]>({
    queryKey: QK_GET_CUSTOMER_GROUPS(),
    queryFn: () => customerGroupsApi.list(),
  });

  return {
    ...query,
    data: query.data ?? [],
  };
}
